import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal } from "./Reveal";

export default function Testimonials() {
  return (
    <section id="temoignages" className="py-24 md:py-32 px-6 md:px-10 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Ils nous font confiance</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight text-forest leading-[1.1]">
              Des familles rassurées, des seniors épanouis
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-7">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div className="h-full bg-cream/60 border border-forest/5 rounded-3xl p-8 flex flex-col transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:bg-white" data-testid={`testimonial-${i}`}>
                <Quote className="w-9 h-9 text-gold/30" />
                <div className="flex gap-1 mt-4">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 text-gold fill-gold" />
                  ))}
                </div>
                <p className="mt-5 font-cormorant text-2xl leading-snug text-forest flex-1">“{t.quote}”</p>
                <div className="mt-7 flex items-center gap-4">
                  <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover ring-2 ring-gold/30" />
                  <div>
                    <div className="font-medium text-forest text-sm">{t.name}</div>
                    <div className="text-xs text-forest/55">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
